// components
import GridPageAbstract from '../../GridPageAbstract';
import { MoneysBulkIcon } from '../../../icons-lib/bulkIcons';
import config from '../../../config';

export default class CurrencyExchangePairsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'currencyExchangePairs';
        this.Server =
            this.props.context.getState().server.currencyExchangePairs;

        this.headerStartIcon = MoneysBulkIcon;

        this.hiddenColumns = config?.hiddenColumns?.currencyExchangePairs || [];

        this.Head = [
            {
                id: 'fromCurrenciesId',
                label: 'fromCurrency',
                object: 'fromCurrency',
                alignRight: false,
                cell: 'Select',
                display: 'name',
                from: 'currencies',
                filterCell: 'Context',
                filterBy: 'currencies'
            },
            {
                id: 'toCurrenciesId',
                label: 'toCurrency',
                object: 'toCurrency',
                alignRight: false,
                cell: 'Select',
                display: 'name',
                from: 'currencies',
                filterCell: 'Context',
                filterBy: 'currencies'
            },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            },
            {
                id: 'dateModified',
                label: 'dateModified',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            }
        ].filter((column) => !this.hiddenColumns.includes(column.id));
    }
}
